module.exports = __webpack_public_path__ + "static/media/stream.cc81a41a.png";